import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { LottieComponent } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import { NGXLogger } from 'ngx-logger';
import { NavBarComponent } from './components/navbar/navbar.component';
import { NgIf } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { environment } from '../environments/environment';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ButtonModule, CardModule, LottieComponent, NavBarComponent, NgIf, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'PMO2';
  showNavBar = true;
  isTestEnvironment = false;
  environment = environment;

  constructor(
    private logger: NGXLogger,
    private primengConfig: PrimeNGConfig,
    private translateService: TranslateService,
  ) {
    this.logger.debug('AppComponent initialized');
  }

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.translateNg();

    // Controlla se siamo in ambiente di test o dev
    this.isTestEnvironment = environment.name === 'TEST' ; //|| environment.name === 'DEV'

    // Modifica il titolo del browser se siamo in test o dev
    if (this.isTestEnvironment) {
      const envSuffix = environment.name === 'TEST' ? ' (TEST)' : ' (DEV)';
      document.title = 'PMO2' + envSuffix;
    }

    this.logger.info("[APP] PMO2 IS SPINNING UP IN "+ environment.name +" ENV using API URL "+ environment.apiUrl);
  }

  translateNg(): void {
    this.translateService.setDefaultLang('it');
   this.translateService
     .get('primeng')
     .subscribe((res) => this.primengConfig.setTranslation(res));
 }
}
